import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { authConfig, validateAuthConfig, isAuthConfigured } from './config/auth';
import './index.css';
import App from './App';

// Validate and configure Amplify with Cognito settings
if (isAuthConfigured()) {
  validateAuthConfig();
  Amplify.configure(authConfig);
} else {
  console.warn(
    'AWS Cognito is not configured. Authentication features will be disabled.\n' +
    'To enable authentication, copy .env.example to .env and configure your Cognito settings.'
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
